module.exports = __webpack_public_path__ + "static/img/ABC.3cb282b4.png";